import React, {useEffect} from 'react';
import {observer} from 'mobx-react';
import {runInAction} from 'mobx';
import {CheckoutInputElement} from '../../inputs/checkoutInputs';
import store from '../../../s';
import {IAddress} from '../../../i';
import {clearEmptyOptionalFormInput, countryRequiresState, markIncompleteRequiredFields, syncMultilineFormFieldRules} from './button-import-csv/parse-csv-addresses';

type Props = {
    address: IAddress;
    idSuffix: string;
};

const FormMultilineShipments = observer((props: Props) => {
    const {idSuffix} = props;
    const {firstName, lastName, address1, address2, city, state, postalCode, country, isBusinessAddress} = props.address;
    const requiresState = countryRequiresState(country.value);

    useEffect(() => {
        runInAction(() => {
            syncMultilineFormFieldRules(props.address);
            markIncompleteRequiredFields(props.address);
        });
    }, [country.value, props.address]);

    const syncStateAfterCountryChange = () => {
        syncMultilineFormFieldRules(props.address);
        markIncompleteRequiredFields(props.address);
    };

    const clearEmptyOptionalState = () => {
        if (!countryRequiresState(country.value)) {
            clearEmptyOptionalFormInput(state);
        }
    };

    return (
        <div className="form-multiline-shipments">
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={firstName}
                idSuffix={idSuffix}
                label="First Name"
                required={true}
                ariaLabel="Shipping First Name"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={lastName}
                idSuffix={idSuffix}
                label="Last Name"
                required={true}
                ariaLabel="Shipping Last Name"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={address1}
                idSuffix={idSuffix}
                required={true}
                places={true}
                ariaLabel="Shipping Address Line 1"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={address2}
                idSuffix={idSuffix}
                required={false}
                ariaLabel="Shipping Address Line 2"
                onChange={() => clearEmptyOptionalFormInput(address2)}
                onBlur={() => clearEmptyOptionalFormInput(address2)}
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={city}
                idSuffix={idSuffix}
                required={true}
                ariaLabel="Shipping City"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={state}
                idSuffix={idSuffix}
                label="State"
                required={requiresState}
                ariaLabel="Shipping State"
                onChange={clearEmptyOptionalState}
                onBlur={clearEmptyOptionalState}
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={postalCode}
                idSuffix={idSuffix}
                type="text"
                required={true}
                hideSpinner={true}
                ariaLabel="Shipping Postal Code"
            />
            <CheckoutInputElement
                floating={true}
                ab={store.checkout.ab}
                o={country}
                idSuffix={idSuffix}
                label="Country"
                required={true}
                ariaLabel="Shipping Country"
                onChange={syncStateAfterCountryChange}
            />
            <div className="col-12 col-md-6 text-left mt-1">
                <label className="radio-container">
                    <input
                        type="checkbox"
                        aria-label="Business Address"
                        className="radio radio-sm"
                        name="shipping-business-address"
                        value={1}
                        checked={isBusinessAddress}
                        onChange={() => (props.address.isBusinessAddress = !props.address.isBusinessAddress)}
                    />
                    <span className="radio-label">Business Address</span>
                </label>
            </div>
        </div>
    );
});

export default FormMultilineShipments;
